import { AppstoreOutlined, BellFilled, BellOutlined, CarOutlined, EnvironmentOutlined, EuroCircleOutlined, InboxOutlined, PlusCircleOutlined, PoweroffOutlined, SettingOutlined, SolutionOutlined, TableOutlined, TagsOutlined, TeamOutlined, UserOutlined, WarningOutlined } from '@ant-design/icons';
import { Avatar, Badge, Button, Layout, Menu, Popover, Tooltip } from 'antd';
import { getAppStore } from 'core/modules/app/app.store';
import { getAuthStore } from 'core/modules/auth/auth.store';
import { getMediaStore } from 'core/modules/media/media.store';
import { getNotificationStore } from 'core/modules/notifications/notification.store';
import { getRouteStore } from 'core/modules/routes/route.store';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { getWorkspaceStore } from 'core/modules/workspaces/workspace.store';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Notifications } from 'src/components/Notifications/Notifications';
import { TaskDrawer } from 'src/components/Tasks/TaskDrawer';
import { setRouterQuery } from 'src/utils/router';
import styled from 'styled-components';
import { RouteDrawer } from '../Routes/Drawer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function AppLayout(props) {
  var _router$query, _router$query2;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();

  var _getAppStore = getAppStore(),
      isReady = _getAppStore.isReady;

  var _getAuthStore = getAuthStore(),
      isAuthenticated = _getAuthStore.isAuthenticated,
      logout = _getAuthStore.logout,
      user = _getAuthStore.user,
      canManageSettings = _getAuthStore.canManageSettings,
      canManageUsers = _getAuthStore.canManageUsers,
      canManageLabels = _getAuthStore.canManageLabels,
      canManageZones = _getAuthStore.canManageZones,
      canManageCompanies = _getAuthStore.canManageCompanies,
      canManageRates = _getAuthStore.canManageRates,
      canManageRoutes = _getAuthStore.canManageRoutes,
      canManageClients = _getAuthStore.canManageClients,
      canManagePreferences = _getAuthStore.canManagePreferences;

  var _getMediaStore = getMediaStore(),
      getUserMediaSrc = _getMediaStore.getUserMediaSrc;

  var _getWorkspaceStore = getWorkspaceStore(),
      workspaces = _getWorkspaceStore.workspaces;

  var _getNotificationStore = getNotificationStore(),
      notifications = _getNotificationStore.notifications,
      unreadNotifications = _getNotificationStore.unreadNotifications,
      activeNotification = _getNotificationStore.activeNotification,
      setActiveNotification = _getNotificationStore.setActiveNotification,
      markNotificationsAsSeen = _getNotificationStore.markNotificationsAsSeen;

  var _getTaskStore = getTaskStore(),
      tasks = _getTaskStore.tasks,
      getTaskById = _getTaskStore.getTaskById,
      getIncidenceById = _getTaskStore.getIncidenceById,
      pendingIncidences = _getTaskStore.pendingIncidences;

  var _getRouteStore = getRouteStore(),
      routeById = _getRouteStore.routeById,
      pendingRoutes = _getRouteStore.pendingRoutes;

  var _useState = useState(user),
      currentUser = _useState[0],
      setCurrentUser = _useState[1];

  var _useState2 = useState(false),
      isCollapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var activeTask = useMemo(function () {
    if (router.query.taskId) {
      return getTaskById(router.query.taskId);
    }

    if (router.query.incidenceId) {
      var incidence = getIncidenceById(router.query.incidenceId);
      return getTaskById(incidence === null || incidence === void 0 ? void 0 : incidence.taskId);
    }
  }, [tasks, (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.taskId]);
  var activeRoute = useMemo(function () {
    return routeById(router.query.routeId);
  }, [routeById, (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.routeId]);
  var activeSections = useMemo(function () {
    var sections = [];

    if (router.asPath.includes('/work')) {
      sections.push('/work');
    }

    if (router.asPath.includes('/tasks')) {
      sections.push('/tasks');
    }

    if (router.asPath.includes('/incidences')) {
      sections.push('/incidences');
    }

    if (router.asPath.includes('/routes')) {
      sections.push('/routes');
    }

    if (router.asPath.includes('/settings')) {
      sections.push('/settings');
    }

    if (router.asPath.includes('/settings/report-rates') || router.asPath.includes('/settings/mileage-rates')) {
      sections.push('/settings/rates');
    }

    if (router.asPath.includes('/settings/insurances') || router.asPath.includes('/settings/laboratories')) {
      sections.push('/settings/companies');
    }

    return sections;
  }, [router.asPath]);
  var selectedKeys = useMemo(function () {
    if (router.asPath.includes('/routes')) {
      return ['/routes'];
    }

    if (!router.asPath.includes('?')) {
      return [router.asPath];
    }

    return [router.asPath.substring(0, router.asPath.indexOf('?'))];
  }, [router.asPath]);
  var canRender = useMemo(function () {
    var _router$asPath;

    return isAuthenticated || ((_router$asPath = router.asPath) === null || _router$asPath === void 0 ? void 0 : _router$asPath.includes('/guest'));
  }, [isAuthenticated, router.asPath]);
  useEffect(function () {
    user && setCurrentUser(user);
  }, [user]);
  return /*#__PURE__*/_jsx(Layout, {
    children: /*#__PURE__*/_jsxs(Layout, {
      children: [/*#__PURE__*/_jsxs(Sider, {
        width: 250,
        collapsible: true,
        theme: "light",
        hidden: !isAuthenticated,
        onCollapse: setCollapsed,
        children: [/*#__PURE__*/_jsxs(Menu, {
          mode: "inline",
          defaultSelectedKeys: [],
          selectedKeys: selectedKeys,
          defaultOpenKeys: activeSections,
          className: "main-menu",
          children: [/*#__PURE__*/_jsx(Menu.Item, {
            children: /*#__PURE__*/_jsx("img", {
              className: "logo",
              src: "/images/balcle-logo.png",
              alt: "logo",
              width: isCollapsed ? 50 : 100
            })
          }), /*#__PURE__*/_jsxs(Menu.SubMenu, {
            icon: /*#__PURE__*/_jsx(InboxOutlined, {}),
            title: t('nav.work'),
            children: [workspaces.map(function (workspace) {
              return /*#__PURE__*/_jsx(Menu.Item, {
                className: "workspace-item",
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/work/".concat(workspace.id),
                  children: /*#__PURE__*/_jsx(Tooltip, {
                    title: workspace.title,
                    children: /*#__PURE__*/_jsxs("a", {
                      children: [/*#__PURE__*/_jsx("span", {
                        className: "color",
                        style: {
                          backgroundColor: workspace.color
                        }
                      }), workspace.title]
                    })
                  })
                })
              }, "/work/".concat(workspace.id));
            }), /*#__PURE__*/_jsx(Menu.Item, {
              icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
              children: /*#__PURE__*/_jsx(Link, {
                href: "/work/new",
                children: t('nav.workNew')
              })
            }, "/work/new")]
          }, "/work"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(TableOutlined, {}),
            children: /*#__PURE__*/_jsx(Link, {
              href: "/tasks/list",
              children: t('nav.tasks')
            })
          }, "/tasks/list"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(WarningOutlined, {}),
            children: /*#__PURE__*/_jsx(Link, {
              href: "/incidences",
              children: /*#__PURE__*/_jsx(Tooltip, {
                title: pendingIncidences.length ? t('incidences.tooltip', {
                  count: pendingIncidences.length
                }) : undefined,
                children: /*#__PURE__*/_jsxs("a", {
                  children: [t('nav.incidences'), ' ', /*#__PURE__*/_jsx(Badge, {
                    count: pendingIncidences.length,
                    offset: [0, -8]
                  })]
                })
              })
            })
          }, "/incidences"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(CarOutlined, {}),
            children: /*#__PURE__*/_jsx(Link, {
              href: "/routes",
              children: /*#__PURE__*/_jsx(Tooltip, {
                title: pendingRoutes.length && canManageRoutes ? t('route.pendingTooltip', {
                  count: pendingRoutes.length
                }) : undefined,
                children: /*#__PURE__*/_jsxs("a", {
                  children: [t('nav.routes'), ' ', canManageRoutes && /*#__PURE__*/_jsx(Badge, {
                    count: pendingRoutes.length,
                    offset: [0, -8]
                  })]
                })
              })
            })
          }, "/routes"), canManageSettings && /*#__PURE__*/_jsxs(Menu.SubMenu, {
            icon: /*#__PURE__*/_jsx(SettingOutlined, {}),
            title: t('nav.settings'),
            children: [canManageUsers && /*#__PURE__*/_jsx(Menu.Item, {
              icon: /*#__PURE__*/_jsx(TeamOutlined, {}),
              children: /*#__PURE__*/_jsx(Link, {
                href: "/settings/users",
                children: t('nav.users')
              })
            }, "/settings/users"), canManageLabels && /*#__PURE__*/_jsx(Menu.Item, {
              icon: /*#__PURE__*/_jsx(TagsOutlined, {}),
              children: /*#__PURE__*/_jsx(Link, {
                href: "/settings/labels",
                children: t('nav.labels')
              })
            }, "/settings/labels"), canManageZones && /*#__PURE__*/_jsx(Menu.Item, {
              icon: /*#__PURE__*/_jsx(EnvironmentOutlined, {}),
              children: /*#__PURE__*/_jsx(Link, {
                href: "/settings/zones",
                children: t('nav.zones')
              })
            }, "/settings/zones"), canManageCompanies && /*#__PURE__*/_jsxs(Menu.SubMenu, {
              icon: /*#__PURE__*/_jsx(SettingOutlined, {}),
              title: t('nav.companies'),
              children: [/*#__PURE__*/_jsx(Menu.Item, {
                icon: /*#__PURE__*/_jsx(AppstoreOutlined, {}),
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/settings/insurances",
                  children: t('nav.insurances')
                })
              }, "/settings/insurances"), /*#__PURE__*/_jsx(Menu.Item, {
                icon: /*#__PURE__*/_jsx(AppstoreOutlined, {}),
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/settings/laboratories",
                  children: t('nav.laboratories')
                })
              }, "/settings/laboratories")]
            }, "/settings/companies"), canManageRates && /*#__PURE__*/_jsxs(Menu.SubMenu, {
              icon: /*#__PURE__*/_jsx(EuroCircleOutlined, {}),
              title: t('nav.rates'),
              children: [/*#__PURE__*/_jsx(Menu.Item, {
                icon: /*#__PURE__*/_jsx(TableOutlined, {}),
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/settings/report-rates",
                  children: t('nav.reportRates')
                })
              }, "/settings/report-rates"), /*#__PURE__*/_jsx(Menu.Item, {
                icon: /*#__PURE__*/_jsx(CarOutlined, {}),
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/settings/mileage-rates",
                  children: t('nav.mileageRates')
                })
              }, "/settings/mileage-rates")]
            }, "/settings/rates"), canManageClients && /*#__PURE__*/_jsx(Menu.Item, {
              icon: /*#__PURE__*/_jsx(SolutionOutlined, {}),
              children: /*#__PURE__*/_jsx(Link, {
                href: "/settings/clients",
                children: t('nav.clients')
              })
            }, "/settings/clients"), canManagePreferences && /*#__PURE__*/_jsx(Menu.Item, {
              icon: /*#__PURE__*/_jsx(SettingOutlined, {}),
              children: /*#__PURE__*/_jsx(Link, {
                href: "/settings/preferences",
                children: t('nav.preferences')
              })
            }, "/settings/preferences")]
          }, "/settings")]
        }), currentUser && /*#__PURE__*/_jsx(Popover, {
          getPopupContainer: function getPopupContainer(trigger) {
            return trigger.parentElement;
          },
          trigger: activeNotification ? 'hover' : 'click',
          content: /*#__PURE__*/_jsx(Notifications, {}),
          placement: "rightBottom",
          className: "notifications-popover",
          onOpenChange: function onOpenChange(isVisible) {
            if (!isVisible) {
              var seen = notifications.filter(function (notification) {
                return !notification.isSeen;
              });
              markNotificationsAsSeen(seen);
            }
          },
          overlayStyle: {
            zIndex: 100
          },
          children: /*#__PURE__*/_jsx(Tooltip, {
            title: t('notifications.tooltip', {
              count: unreadNotifications
            }),
            children: /*#__PURE__*/_jsx(Badge, {
              count: unreadNotifications,
              offset: [-20, 10],
              children: /*#__PURE__*/_jsx(Button, {
                block: true,
                type: "link",
                icon: unreadNotifications > 0 ? /*#__PURE__*/_jsx(BellFilled, {}) : /*#__PURE__*/_jsx(BellOutlined, {}),
                className: "notifications",
                children: /*#__PURE__*/_jsx("span", {
                  className: "label",
                  children: t('notifications.label')
                })
              })
            })
          })
        }), /*#__PURE__*/_jsxs(Menu, {
          mode: "inline",
          defaultSelectedKeys: [],
          selectedKeys: [router.asPath],
          children: [/*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Avatar, {
              size: "small",
              src: getUserMediaSrc(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id),
              icon: /*#__PURE__*/_jsx(UserOutlined, {})
            }),
            children: currentUser && /*#__PURE__*/_jsx(Link, {
              href: "/user/profile",
              children: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name
            })
          }, "/user/profile"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(PoweroffOutlined, {}),
            onClick: logout,
            children: t('nav.logout')
          }), /*#__PURE__*/_jsx(Menu.Divider, {})]
        })]
      }), /*#__PURE__*/_jsxs(Layout, {
        children: [/*#__PURE__*/_jsx(Content, {
          children: canRender && props.children
        }), isReady && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TaskDrawer, {
            isVisible: !!activeTask,
            fromNotifications: true,
            canToggleExpanded: true,
            taskId: activeTask === null || activeTask === void 0 ? void 0 : activeTask.id,
            onClose: function onClose() {
              setActiveNotification();
              setRouterQuery(router, 'taskId', undefined);
              setRouterQuery(router, 'incidenceId', undefined);
            }
          }), /*#__PURE__*/_jsx(RouteDrawer, {
            isVisible: !!activeRoute,
            routeId: activeRoute === null || activeRoute === void 0 ? void 0 : activeRoute.id,
            onClose: function onClose() {
              setRouterQuery(router, 'routeId', undefined);
            }
          })]
        })]
      })]
    })
  });
} // Styles

var Sider = styled(Layout.Sider).withConfig({
  displayName: "AppLayout__Sider",
  componentId: "sc-n5uca2-0"
})([".ant-layout-sider-children{display:flex;flex-direction:column;}.main-menu{flex:1;}.ant-avatar{margin-left:-11px;}.ant-avatar,.ant-avatar > .anticon{line-height:24px !important;}.logo{margin-left:-5px;transition:all 0.2s ease-in-out;}.notifications{height:40px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-align:left;.anticon{margin-right:5px;transition:all 0.3s ease-in-out;}.label{color:black;margin-right:6px;}}&.ant-layout-sider-collapsed{.logo{margin-left:-15px;}.ant-avatar{margin-left:-5px;}.notifications{text-align:center;.anticon{margin-right:0px;}.label{display:none;opacity:0;}}}.workspace-item{.color{width:6px;height:20px;position:absolute;border-radius:2px;top:calc(50% - 10px);left:28px;}}"]);
var Content = styled(Layout.Content).withConfig({
  displayName: "AppLayout__Content",
  componentId: "sc-n5uca2-1"
})(["overflow-y:auto;height:100vh;padding:0 0px;"]);